<template>
  <div class="drawer-panel-inner">
    <div
      ref="items-wrap"
      class="drawer-panel-inner__items-wrap"
    >
      <slot />
    </div>
    <div
      ref="controls"
      class="drawer-panel-inner__controls"
    >
      <slot name="footer">
        <ui-button
          wide
          secondary
          large
          text="Сбросить"
          @click="$emit('clear')"
        />

        <ui-button
          wide
          large
          text="Применить"
          @click="$emit('apply')"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll  } from 'body-scroll-lock';
import { debounce } from 'throttle-debounce';

export default {
  data() {
    return {
      isScrollEnabled: false,
    };
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.fitScroll);
    enableBodyScroll(this.$el);
  },

  mounted() {
    this.fitScroll();
    window.addEventListener('resize', this.fitScroll);
    this.disableScroll();
  },

  methods: {
    disableScroll() {
      disableBodyScroll(this.$el, {
        allowTouchMove: el => {
          // если нет скролла лочим скролл
          if (!this.isScrollEnabled) return false;
          const classList = el.classList;

          // если есть скролл то делаем исключения для нод которые можно скроллить
          return classList.contains('mobile-multiselect-item') || classList.contains('scrollable');
        }
      });
    },
    fitScroll: debounce(50, function () {
      const controlsWrap = this.$refs['controls'];
      const controlsWrapHeight = controlsWrap.offsetHeight;
      const controlsWrapTopOffset = controlsWrap.getBoundingClientRect().top
      const itemsWrap = this.$refs['items-wrap'];
      const itemsWrapHeight = itemsWrap.offsetHeight;
      const windowHeight = this.$el.offsetParent.offsetHeight;
      const difference = (controlsWrapTopOffset + controlsWrapHeight) - windowHeight;

      if (difference <= 0 ) {
        itemsWrap.style.height = '100%';

        if(this.isScrollEnabled) {
          this.isScrollEnabled = false;
        }

        return;
      }

      if (!this.isScrollEnabled) {
        this.isScrollEnabled = true;
      }

      itemsWrap.style.height = `${itemsWrapHeight - difference }px`;
    })
  }
}
</script>


<style lang="scss">
  .drawer-panel-inner {
    height: 100%;
    display: flex;
    flex-direction: column;

    .drawer-panel-item:last-child {
      border: none;
    }

    &__items-wrap {
      overflow: hidden auto;
      min-height: 200px;
    }

    &__controls {
      display: flex;
      padding: 16px;
      margin-top: auto;
      background: $white;

      .ui-button + .ui-button:last-child {
        margin-left: 8px;
      }
    }
  }
</style>